import request from "@/utils/request.js";

export function getOssKey(params) {
  return request({
    url: "/operateService/api/oss/object/getPolicy",
    method: "post",
    data: params,
  });
}
